import React from 'react';

class EditRoom extends React.Component {
  render() {
    return (
      <div>
        <h1 className="headingOne">Edit Room Page</h1>
        <div className="content">
            This is where you will Edit rooms
        </div>
      </div>
    );
  }
}

export default EditRoom;
 